import { render, staticRenderFns } from "./EmailBlasts.vue?vue&type=template&id=c2f45ef4&scoped=true"
import script from "./EmailBlasts.vue?vue&type=script&lang=js"
export * from "./EmailBlasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f45ef4",
  null
  
)

export default component.exports